/**
 * Which KYC rows stay hidden on the default list.
 * Status 0 (pending) and 1 (approved) are never hidden.
 * Status 2/3 with no transaction and no ledger are hidden, except the migrated pair.
 */
export const KYC_ALWAYS_VISIBLE_UIDS = new Set([
  "OkUzKMMO31a1sFFCRVnbYpjIRmf1",
  "OiBDcrXdEWwepuj6XHdB",
]);

export function profileUid(profile) {
  return profile?.user_id || profile?.id || "";
}

function profileIds(profile) {
  return [profile?.user_id, profile?.id, profile?.users_doc_id, profile?.doc_id].filter(Boolean);
}

export function shouldHideKycProfile(profile, activity) {
  const ids = profileIds(profile);
  if (!ids.length || ids.some((id) => KYC_ALWAYS_VISIBLE_UIDS.has(id))) return false;
  const status = Number(profile?.app_user_status);
  if (status === 0 || status === 1) return false;
  if (status !== 2 && status !== 3) return false;
  if (!activity || activity.error) return false;
  return (activity.transactions || 0) === 0 && (activity.ledgers || 0) === 0;
}
